import React from 'react';
import i18n from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import { type AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import SkillsView from './view/SkillsView';
import SkillsDetails from './details/SkillsDetails';

import buttons from './SkillsButtons';
import events from './SkillsEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18n.addResourceBundle('en', 'core', en);
i18n.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('skills'),
	routes: [
		{
			path: 'skills/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'skills'),
			element: (
				<DetailsPage
					key="skills/add"
					module="skills"
					tabs={SkillsDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'skills/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'skills'),
			element: (
				<DetailsPage
					key="skills/details"
					module="skills"
					tabs={SkillsDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'skills/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'skills'),
			element: (
				<ViewPage
					key="skills/view"
					module="skills"
					content={{ type: 'tabs', tabs: SkillsView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
